import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Section } from '../components'
import { LuSearchX } from "react-icons/lu"
import { IoIosCheckmark, IoIosClose } from "react-icons/io"
import { Format, StreetAddress, mmddyyyy } from '@oneethos/shared'

export const SearchResultsPage: React.FC = () => {
  const [showInstallers, setShowInstallers] = useState(true)
  const [showProjects, setShowProjects] = useState(false)
  const location = useLocation()
  const navigate = useNavigate()
  const { installers, projects } = location.state || {}

  useEffect(() => {
    if ((installers.length === 0) && projects.length > 0) {
      setShowInstallers(false)
      setShowProjects(true)
    }
    else if (installers.length > 0 && (projects.length === 0)) {
      setShowInstallers(true)
      setShowProjects(false)
    }
  }, [installers, projects])

  const displayProjects = () => {
    setShowInstallers(false)
    setShowProjects(true)
  }

  const displayInstallers = () => {
    setShowInstallers(true)
    setShowProjects(false)
  }

  return (
    <Section>
      <div className="section-title">
        <h2 className="margin-bottom-0">Search Results</h2>
      </div>
      <div className="mb-3">
        <button
          className={`btn ${showInstallers ? 'btn-primary' : 'btn-light'} me-2`}
          onClick={displayInstallers}
        >
          Installers ({installers?.length})
        </button>
        <button
          className={`btn ${showProjects ? 'btn-primary' : 'btn-light'}`}
          onClick={displayProjects}
        >
          Projects ({projects?.length})
        </button>
      </div>

      {showInstallers && installers?.length > 0 && (
        <div className="table-list-wrap">
          <table className="table table-hover">
            <thead>
              <tr>
                <th>Installer ID</th>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Access Level</th>
                <th className="text-center">Active</th>
              </tr>
            </thead>
            <tbody>
              {installers.map((installer) => (
                <tr
                  className="align-middle"
                  key={installer._id}
                  style={{ cursor: 'pointer' }}
                  onClick={() => navigate(`/installer-admin/${installer?.installerID}`)}
                >
                  <td>{installer.installerID}</td>
                  <td>{installer.name}</td>
                  <td>{installer.email}</td>
                  <td>{installer.phone}</td>
                  <td>{installer.access}</td>
                  <td className="text-center">
                    {installer.active !== false ?
                      <IoIosCheckmark color='green' size={35} /> :
                      <IoIosClose color='red' size={35} />
                    }
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {showProjects && projects?.length > 0 && (
        <div className="table-list-wrap">
          <table className="table table-hover">
            <thead>
              <tr>
                <th>Name</th>
                <th className='text-nowrap'>App ID</th>
                <th>Phone</th>
                <th>Installer ID</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {projects.map((project) => (
                <tr
                  className="align-middle"
                  key={project._id}
                  style={{ cursor: 'pointer' }}
                  onClick={() => navigate(`/project/${project._id}`)}
                >
                  <td>
                    <div>{project.customerName || (
                      (project.firstName || project.lastName) &&
                      `${project.firstName} ${project.lastName}`
                    )}</div>
                    <div className='text-muted small fw-normal'>{project.email}</div>
                    <div className='text-muted small fw-normal'>
                      {project.address || (
                        project.installationAddress &&
                        StreetAddress.toString(project.installationAddress)
                      )}
                    </div>
                  </td>
                  <td>{project.appId}</td>
                  <td className='text-nowrap'>{Format.phone(project.phone)}</td>
                  <td>{project.installerID}</td>
                  <td>{project.installersStatus}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {(!showInstallers || !installers?.length) &&
        (!showProjects || !projects?.length) && (
          <div className="text-center p-5">
            <LuSearchX size={48} className="mb-3" />
            <h4>We couldn't find anything matching your search.</h4>
            <p>Try again with a different input.</p>
          </div>
        )}
    </Section>
  )
}

export default SearchResultsPage
